import { render, staticRenderFns } from "./ProjectInstance.vue?vue&type=template&id=70026b26&scoped=true&"
import script from "./ProjectInstance.vue?vue&type=script&lang=js&"
export * from "./ProjectInstance.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInstance.vue?vue&type=style&index=0&id=70026b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70026b26",
  null
  
)

export default component.exports